import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../../test-utils/html-validate";

describe("tab-switcher", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-tab-switcher/>`);
        const el = await page.find("ux-tab-switcher");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-tab-switcher tab-id="1">
                Test
            </ux-tab-container>`
        );
        const el = await page.find("ux-tab-switcher");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should reflect state to child ux-radio-button", async () => {
        const page = await newE2EPage();
        await page.setContent(templateWithRadioButtons());
        await page.waitForChanges();
        const tabA = await page.find("ux-tab[name='a']");
        const tabB = await page.find("ux-tab[name='b']");
        const tabSwitcherA = await page.find("ux-tab-switcher[tab-id='a']");
        const tabSwitcherB = await page.find("ux-tab-switcher[tab-id='b']");
        const radioButtonA = await tabSwitcherA.find("ux-radio-button");
        const radioButtonB = await tabSwitcherB.find("ux-radio-button");
        await page.waitForChanges();
        expect(tabB).toHaveClass("is-active");
        expect(tabA).not.toHaveClass("is-active");
        await tabSwitcherA.click();
        await page.waitForChanges();
        expect(tabA).toHaveClass("is-active");
        expect(tabB).not.toHaveClass("is-active");
        const radioInputA = await radioButtonA.findAll("input:checked");
        const radioInputB = await radioButtonB.findAll("input:checked");
        expect(radioInputA.length).toBe(1);
        expect(radioInputB.length).toBe(0);
    });

    it("should render valid html", async () => {
        await testValidHtml(templateWithRadioButtons());
    });
});

function templateWithRadioButtons() {
    return `
    <div class="ux-button-group">
        <ux-tab-switcher tab-id="a">
            <ux-radio-button
                name="radio-1"
                label="Radio Button Label 1"
                value="radio-1"
            ></ux-radio-button>
        </ux-tab-switcher>
        <ux-tab-switcher tab-id="b">
            <ux-radio-button
                name="radio-2"
                label="Radio Button Label 2"
                value="radio-2"
            ></ux-radio-button>
        </ux-tab-switcher>
    </div>
    <ux-tab-container no-navigation active-tab-id="b">
        <ux-tab name="a" tab-id="a">
            Lorem ipsum dolor Radio Button 1
        </ux-tab>
        <ux-tab name="b" tab-id="b">
            Lorem ipsum dolor Radio Button 2
        </ux-tab>
    </ux-tab-container>
    `;
}
